<template>
    <v-btn
        class="d-flex align-center primary--text"
        :class="button_class"
        :style="button_style"
        :ripple="false"
        plain
        @click="$emit('click')"
    >
        <v-icon
            color="primary"
            aria-hidden="true"
            small
        >
            {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
        <span :class="text_size_class" class="font-weight-medium ml-1">
            <slot />
        </span>
    </v-btn>
</template>

<script>
/**
 * A text-style button that shows expandable/collapsible below it.
 * Great for things like "Advanced Settings" sections.
 */

export default {
    name: 'TextExpandButton',

    props: {
        expanded: {
            type: Boolean,
            default: false
        },

        button_class: {
            type: String,
            default: ''
        },

        text_size: {
            type: String,
            default: 'body-2',
            validator: (value) => {
                return ['caption', 'body-2', 'body-1', 'subtitle-2', 'subtitle-1', 'h6', 'h5'].includes(value);
            }
        },

        text_transform: {
            type: String,
            default: 'capitalize',
            validator: (value) => {
                return ['none', 'uppercase', 'lowercase', 'capitalize'].includes(value);
            }
        }
    },

    computed: {
        text_size_class() {
            return `text-${this.text_size}`;
        },

        button_style() {
            return {
                textTransform: this.text_transform
            };
        }
    }
}
</script>
